import React from 'react';
import { Link } from 'gatsby';


export const Hero3 = () => {

  return (
    <div className="container">
      <div className="feature feature-2">
        <div className="feature__wrap">  
          <div className="feature__left">
            
            <img
              src={require('../../../components/images/adminheropro.png')}
              alt="#"
              className="feature__img"
            />
          </div>
          <div className="feature__right">
            <h2 className="feature__lead feature__lead--1 showcase__lead">
              Easily Create Admin Dashboards and landing pages
            </h2>
            <p className="feature__text mb-5">
              Use the Contrast UI components to easily create Admin dashboards and landing pages for different projects. Contrast custom components was created with this use cases in mind.
              View an example of dashboards created using contrast below
            </p>
            <a target="_blank" href="https://cdbootstrap-free-demo.netlify.app/" className="btn1 btn__inverse" rel="noreferrer">
              View dashboard
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
